export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";